export default "__VITE_ASSET__w_x85M_X__"